import '../editor-theme.scss';

const theme = {
    ltr: 'priority-editor__text_ltr',
    rtl: 'priority-editor__text_rtl',
    placeholder: 'priority-editor__placeholder',
    paragraph: 'priority-editor__paragraph',
    quote: 'priority-editor__quote',
    heading: {
        h1: 'priority-editor__heading_h1',
        h2: 'priority-editor__heading_h2',
        h3: 'priority-editor__heading_h3',
        h4: 'priority-editor__heading_h4',
        h5: 'priority-editor__heading_h5'
    },
    list: {
        nested: {
            listitem: 'editor-nested-listitem'
        },
        ol: 'priority-editor__list_ol',
        ul: 'priority-editor__list_ul',
        listitem: 'priority-editor__list-item'
    },
    image: 'priority-editor__image',
    link: 'priority-editor__link',
    text: {
        bold: 'priority-editor__text_bold',
        italic: 'priority-editor__text_italic',
        underline: 'priority-editor__text_underline',
        strikethrough: 'priority-editor__text_strikethrough',
        underlineStrikethrough: 'priority-editor__text_underlineStrikethrough'
    },
    table: 'priority-editor__table',
    tableCell: 'priority-editor__tableCell'
};

export default theme;
